import { render, staticRenderFns } from "./project-evaluate.vue?vue&type=template&id=4a64e3d7&scoped=true&"
import script from "./project-evaluate.vue?vue&type=script&lang=js&"
export * from "./project-evaluate.vue?vue&type=script&lang=js&"
import style0 from "./project-evaluate.vue?vue&type=style&index=0&id=4a64e3d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64e3d7",
  null
  
)

export default component.exports